"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./TextArea.scss");
var TextArea = /** @class */ (function (_super) {
    __extends(TextArea, _super);
    function TextArea(props) {
        var _this = _super.call(this, props) || this;
        _this.hintId = _this.guid();
        _this.counterId = _this.guid();
        _this.textAreaId = _this.guid();
        _this.shouldComponentUpdate = function (newProps) {
            var currentText = _this.state.currentText;
            if (newProps.input !== currentText) {
                _this.state.currentText = newProps.input;
            }
            if (newProps.options && newProps.options.disabled !== _this.state.disabled) {
                _this.state.disabled = newProps.options.disabled;
            }
            return true;
        };
        _this.onChange = function (event) {
            _this.setState({ currentText: event.currentTarget.value });
            var _a = _this.props, events = _a.events, options = _a.options;
            if (events && events.onChange) {
                events.onChange(event);
            }
            if (options && options.maxLength && event.target.value.length > options.maxLength) {
                event.preventDefault();
            }
        };
        _this.onKeyPress = function (event) {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            if (events && events.onKeyPress) {
                events.onKeyPress(currentText, event);
            }
        };
        _this.onBlur = function () {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            if (events && events.onBlur) {
                events.onBlur(currentText);
            }
            _this.setState({ focused: false });
        };
        _this.onFocus = function (event) {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            if (events && events.onFocus) {
                events.onFocus(currentText, event);
            }
            _this.setState({ focused: true });
        };
        _this.render = function () {
            var _a = _this.props, error = _a.error, errorText = _a.errorText, hintText = _a.hintText, options = _a.options, placeHolder = _a.placeHolder, testId = _a.testId, title = _a.title;
            var _b = _this.state, currentText = _b.currentText, focused = _b.focused;
            var descIds = [];
            if (options && options.maxLength) {
                descIds.push(_this.counterId);
            }
            if (hintText && error) {
                descIds.push(_this.hintId);
            }
            return (React.createElement("div", { className: [options ? options.className : "", "rel"].join(" "), "data-testid": testId },
                _this.props.title && (React.createElement("label", { htmlFor: _this.textAreaId, className: [
                        styles.textareaLabel,
                        options && options.disabled ? "disabled" : "",
                        "formfield-label inline-flex",
                        error ? "error" : "",
                    ].join(" ") },
                    title,
                    hintText && !error && (React.createElement("span", { className: "hidden-spoken" }, ": " + hintText)))),
                options && options.maxLength && (React.createElement("span", { id: _this.counterId, className: ["color-ui-gray", styles.charCounter, "pad-b-xxs"].join(" "), "aria-live": options.maxLength - currentText.length <= 20 ? "assertive" : "polite", "aria-atomic": false, "aria-label": currentText.length + " out of " + options.maxLength + " characters" }, currentText.length + "/" + options.maxLength)),
                React.createElement("textarea", { id: _this.textAreaId, className: "line-h-md", placeholder: placeHolder, "aria-invalid": _this.props.error ? true : undefined, "aria-describedby": descIds.length === 0 ? undefined : descIds.join(" "), maxLength: options ? options.maxLength : undefined, value: currentText, onChange: _this.onChange, onKeyPress: _this.onKeyPress, onBlur: _this.onBlur, onFocus: _this.onFocus, disabled: options ? options.disabled : undefined, "aria-label": options ? options.accessibility : undefined }),
                !error && _this.props.hintText && (React.createElement("div", { className: ["formfield-msg"].join(" "), role: "tooltip", tabIndex: focused ? 0 : -1 }, hintText)),
                error && _this.props.errorText && (React.createElement("div", { id: _this.hintId, className: ["formfield-msg"].join(" "), "aria-atomic": true, tabIndex: focused ? 0 : -1, "aria-live": focused && error ? "assertive" : undefined }, errorText))));
        };
        _this.state = {
            currentText: props.input ? props.input : "",
            disabled: props.options.disabled || false,
        };
        _this.onKeyPress = _this.onKeyPress.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }
    TextArea.prototype.guid = function () {
        return "" + this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };
    TextArea.prototype.S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    TextArea.defaultProps = {
        options: {},
    };
    return TextArea;
}(React.Component));
exports.default = TextArea;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/TextArea/TextArea.js
// module id = 1822
// module chunks = 8